import { ApplicationStatus, LoanApplication, OfferType } from '@features/loan-application/loan-application.model'

const pendingStatuses = [
  ApplicationStatus.SUBMITTED,
  ApplicationStatus.DECISION,
  ApplicationStatus.DECISION_ERROR,
  ApplicationStatus.AML_CHECK,
  ApplicationStatus.CONFIRMED,
  ApplicationStatus.BANK_STATEMENT_PROVIDED,
  ApplicationStatus.FRAUD_CHECK,
  ApplicationStatus.PARTNER_OFFER_REQUESTED
]
export const pendingDecision = (application: LoanApplication) => {
  return pendingStatuses.includes(application.status)
    || (application.status === ApplicationStatus.OFFERED && application.offer?.type === OfferType.BASE)
}
